import {createContext} from 'react';

const managersContext = createContext();

export default managersContext;